import styled from "styled-components";

import { ArrowLightRight } from "~/components/icons/ArrowLight";

const Style = styled.div<{ hasPadding?: boolean; clickable: boolean }>`
  height: 50px;

  display: flex;
  gap: 15px;
  justify-content: space-between;
  align-items: center;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;

  text-align: center;
  text-transform: uppercase;

  background: white;
  border-radius: 4px;
  color: #1f1f1f;

  ${(params) => params.hasPadding && `padding: 8px;`}
  ${(params) => params.clickable && `cursor: pointer;`}
`;

export const Container = ({
  hasPadding = true,
  clickable = false,
  children,
}: {
  hasPadding: boolean;
  clickable: boolean;
  children: React.ReactNode;
}) => (
  <Style hasPadding={hasPadding} clickable={clickable}>
    {children}
    {clickable && <ArrowLightRight />}
  </Style>
);
